<template>
	<div :class="['mc', { 'nowrap': !settings.wrap }, { 'editable': settings.editable }]">
		<div v-if="settings.editable" class="mc-input">
			<nk-dropdown :options="settings.dropdown" v-model="dropdownSelectedItem" @update:modelValue="dropdownSelectedItemChanged" :data="dropdownData" :tabindex="tabindex" :startup="startup ? true : null" ref="dropdown"></nk-dropdown>
		</div>
		<div :class="['mc-items']" ref="items">
			<div class="mc-item" v-if="settings.showEmptyLabel && !settings.editable && selecteds.length === 0">
				<div class="mc-item-name mc-empty">{{ $t('empty-items') }}</div>
			</div>
			<div class="mc-item" v-for="(x, i) of selecteds" :key="x.id" tabindex="0" :class="{ 'focused': activeIndex == i }" @click="(e) => onItemClicked(e, i)">
				<div v-if="settings.editable" class="mc-item-del" @click="() => removeItem(x)"><i class="fal fa-trash"></i></div>
				<div class="mc-item-name" v-html="settings.display(x).toLocaleDigits()"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import TabOrder from '~/statics/taborder-functions'

	export default {
		props: {
			options: {},
			value: { type: Array },
			data: { type: Array },
			tabindex: { type: [String, Number] },
			startup: { type: Boolean }
		},
		emits: ['update:modelValue', 'resized'],
		data() {
			return {
				settings: {
					wrap: true,
					editable: true,
					dropdown: {
						searchRequestFilter: this.onDropdownSearchRequestFilter,
					},
					comparer: (first, second) => first === second,
					display: (item) => item,
					showEmptyLabel: false,
					maxSelectedCount: 0
				},

				selecteds: [],
				dropdownSelectedItem: null,
				activeIndex: -1
			}
		},
		computed: {
			dropdownData() {
				return this.data
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					if (val !== oldVal) this.settings = _.merge({}, this.settings, val)
				}
			},
			value: {
				immediate: true,
				handler(val) {
					this.selecteds = val
					setTimeout(() => {
						this.emitAutoSize()
						this.emitSize()
					}, 200)
				}
			},
			'settings.editable': {
				handler(val, oldVal) {
					if (val !== oldVal) {
						this.defer(() => {
							let grandParentType = this.grandParentType()
							TabOrder.subscribeKeys(grandParentType, this)
						}, 500)
					}
				}
			}
		},
		mounted() {

			// assigning id to datas if not given
			// id is required for selected's v-for to work properly
			// otherwise it selects all of the items by selecting one
			for (let index = 0; index < this.data.length; index++)
				if (!this.data[index].id)
					this.data[index].id = this.idGenerator(5)

		},
		methods: {
			editHandler(mode) {
				this.settings.editable = mode
			},
			emitSize() {
				if (this.$refs.dropdown == null) {
					return
				}

				let $el = $(this.$el)

				let size = {
					width: parseFloat($el.width()),
					height: parseFloat($el.height())
				}

				size.width += parseFloat($el.css('border-left-width')) + parseFloat($el.css('border-right-width'))
				size.height += parseFloat($el.css('border-top-width')) + parseFloat($el.css('border-bottom-width'))

				this.$emit('resized', size)

				this.defer(() => {
					this.$el.dispatchEvent(new Event('resize'))
				}, 50)
			},
			emitAutoSize() {
				if (this.$refs.dropdown == null) {
					return
				}

				let w = $(this.$refs.dropdown.$el).width()
				$(this.$el).css('max-width', w)

				this.emitSize()

				$(this.$el).css('max-width', 'unset')
			},
			removeItem(tag) {
				if (this.settings.editable !== true) {
					return
				}

				if (this.selecteds.tryRemove(tag)) {
					this.$emit('update:modelValue', this.selecteds)

					if (this.selecteds.length > 0 && this.activeIndex > 0) {
						this.activeIndex -= 1
						this.refocusActiveSelected()
					} else {
						this.refocusDropdown()
					}

					this.emitAutoSize()
					this.emitSize()
				}
			},
			refocusActiveSelected() {
				this.defer(() => $(this.$el).find('.mc-items .mc-item.focused').focus(), 1)
			},
			refocusDropdown() {
				this.defer(() => {
					let drp = this.$refs.dropdown
					if (drp != null) {
						$(drp.$el).find('input').focus()
					}
				}, 1)
			},
			clearEditor() {
				this.dropdownSelectedItem = null
			},

			dropdownSelectedItemChanged(val) {
				if (val == null) {
					return
				}

				if (!this.selecteds) {
					this.selecteds = []
				}

				if (this.settings.maxSelectedCount > 0 && this.selecteds.length >= this.settings.maxSelectedCount) {
					this.selecteds.shift()
				}

				this.selecteds.tryPush(val, this.settings.comparer)
				this.defer(this.clearEditor, 1)

				this.$emit('update:modelValue', this.selecteds)
				this.defer(() => this.$refs.dropdown.clear(), 5)

				this.emitAutoSize()
				this.emitSize()
			},
			onDropdownSearchRequestFilter(item, request) {
				if (item != null) {
					if (typeof this.settings.searchRequestFilter === 'function') {
						var res = this.settings.searchRequestFilter(this.selecteds, request)
						request = $.extend(true, {}, request, res)
					}
				}
				return request
			},
			onItemClicked(e, index) {
				this.activeIndex = index
				e.preventDefault()
				e.stopPropagation()
			},

			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'multichoice-nav-left',
					keyCode: [37], // 37:arrow-left
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (!this.selecteds || this.selecteds.length === 0) {
							this.activeIndex = -1
							return
						}

						e.preventDefault()

						if (this.activeIndex === -1) {
							this.activeIndex = 0
							this.refocusActiveSelected()
							return true
						} else if (this.activeIndex < this.selecteds.length - 1) {
							this.activeIndex += 1
							this.refocusActiveSelected()
							return true
						} else {
							this.activeIndex = -1
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'multichoice-nav-right',
					keyCode: [39], // 39:arrow-right
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (!this.selecteds || this.selecteds.length === 0) {
							this.activeIndex = -1
							return
						}

						e.preventDefault()

						if (this.activeIndex === 0) {
							this.activeIndex = -1
							this.refocusDropdown()
							return true
						} else if (this.activeIndex > 0 && this.activeIndex < this.selecteds.length) {
							this.activeIndex -= 1
							this.refocusActiveSelected()
							return true
						} else {
							this.activeIndex = -1
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'multichoice-delete',
					keyCode: [8, 46], // 8:backspace 46:delete
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.activeIndex > -1 && this.activeIndex < this.selecteds.length) {
							let item = this.selecteds[this.activeIndex]
							this.removeItem(item)
						}
					}
				})
			}
		}
	}
</script>

<style src="~/styles/multichoice.less" lang="less"></style>
